// extracted by mini-css-extract-plugin
export default {"event_date":"social-review-info-EventDate__event_date--2d3vn","bold":"social-review-info-EventDate__bold--1Z_d8"};